import React from "react";

export default function AWS_Auto_Scaling() {
  return (
    <div>
      <h1>What is AWS Auto Scaling</h1>
      <p>
        Route: <code>/aws/auto-scaling</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
